import * as focusTrap from 'focus-trap';
import CartCrossSell from '../components/cart/CartCrossSell';
import CartItem from '../components/cart/CartItem';
import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';

const selectors = {
  minicart: '[data-minicart]',
  drawer: '[data-minicart-drawer]',
  cartIcon: '[data-cart-icon]',
  backdrop: '[data-minicart-backdrop]',
  close: '[data-cart-close]',
  cartItem: '[data-cart-item]',
};

const OPEN_PARAM = 'openMiniCart';

export default class MainMinicart {
  constructor(section) {
    this.el = section.el;
    this._init();

    this.focusTrap = focusTrap.createFocusTrap(selectors.minicart, {
      clickOutsideDeactivates: false,
    });

    const url = new URL(window.location.href);
    if (url.searchParams.has(OPEN_PARAM)) {
      this.openMinicart();
      this.removeOpenParam();
    }
  }

  _init = () => {
    this.headerCartBubble = document.querySelector(selectors.headerCartBubble);
    this.cartIcons = document.querySelectorAll(selectors.cartIcon);

    if (window.location.pathname !== '/cart') {
      this.cartIcons.forEach(icon => {
        icon.addEventListener('click', this.openMinicart);
      });
    }

    this.minicart = this.el.querySelector(selectors.minicart);
    this.drawer = this.el.querySelector(selectors.drawer);

    document.addEventListener('updateCart', res => this.updateCart(res.detail));

    this._attachListeners();
  };

  _attachListeners = () => {
    const close = this.el.querySelector(selectors.close);
    close.addEventListener('click', this.closeMinicart);

    const backdrop = this.el.querySelector(selectors.backdrop);
    backdrop.addEventListener('click', this.closeMinicart);

    const cartItems = this.drawer.querySelectorAll(selectors.cartItem);
    cartItems.forEach(item => {
      new CartItem(item, this.updateCart);
    });

    if (cartItems.length > 0) {
      new CartCrossSell(this.el, cartItems, this.updateCart);
    }
  };

  openMinicart = () => {
    this.minicart.classList.add('is-open');
    disablePageScroll();
    this.focusTrap.activate();
  };

  closeMinicart = () => {
    this.minicart.classList.remove('is-open');
    enablePageScroll();
    this.focusTrap.deactivate();
  };

  updateCart = res => {
    const responseText = res.sections['main-minicart'];
    const mainHtml = new DOMParser().parseFromString(responseText, 'text/html');
    this.drawer.innerHTML = mainHtml.querySelector(selectors.drawer).innerHTML;

    const cartTrigger = res.sections['main-cart-trigger'];
    const triggerHtml = new DOMParser().parseFromString(
      cartTrigger,
      'text/html',
    );

    this.cartIcons.forEach(icon => {
      icon.innerHTML = triggerHtml.querySelector(selectors.cartIcon).innerHTML;
    });

    this._attachListeners();

    if (res.openCart) {
      this.openMinicart();
    }
  };

  removeOpenParam = () => {
    const paramExp = new RegExp(`[\?&]${OPEN_PARAM}+`);
    history.replaceState(
      null,
      '',
      location.pathname +
        location.search.replace(paramExp, '').replace(/^&/, '?') +
        location.hash,
    );
  };
}
